import type React from 'react';
import styles from './LoadingSpinner.module.css';

export interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  color?: string;
  text?: string;
  fullScreen?: boolean;
  className?: string;
  [key: string]: any;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  color,
  text,
  fullScreen = false,
  className,
  ...props
}) => {
  const spinnerStyle: React.CSSProperties = color
    ? {
        borderColor: `${color}20`,
        borderTopColor: color,
      }
    : {};

  return (
    <div
      className={`${styles.container}${className ? ` ${className}` : ''}`}
      data-full-screen={fullScreen ? 'true' : undefined}
      {...props}
    >
      <div className={styles.spinner} data-size={size} style={spinnerStyle} />
      {text && <div className={styles.loadingText}>{text}</div>}
    </div>
  );
};
